import { ReactElement, cloneElement } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

import SampleExamConfirmBody from "@/components/SampleExamConfirm";
import { TRIAL_EXAM_TITLE } from "@/lib/trialExamConfig";
import { setSampleExamOpen, useSampleExamOpen } from "@/lib/sampleExamDialogStore";
import { prefetchTrialQuestions } from "@/lib/trialQuestions";


/**
 * Trigger wrapper for the sample exam confirmation modal.
 *
 * The modal itself is mounted once (see SampleExamModal in AppShell), so it
 * never stacks on top of another overlay no matter where it was triggered.
 */
export const SampleExamDialog = ({ children }: { children: ReactElement }) =>
  cloneElement(children, {
    onClick: (e: React.MouseEvent) => {
      children.props.onClick?.(e);
      // Warm the question cache so the exam opens without a loading flash.
      prefetchTrialQuestions();
      setSampleExamOpen(true);
    },
  });


/** Single mounted instance of the confirmation modal. */
export const SampleExamModal = () => {
  const open = useSampleExamOpen();
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={setSampleExamOpen}>
      <DialogContent
        className="w-[min(94vw,44rem)] max-w-none sm:max-w-none"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogTitle className="sr-only">{TRIAL_EXAM_TITLE}</DialogTitle>

        <SampleExamConfirmBody
          onCancel={() => setSampleExamOpen(false)}
          onStart={() => {
            setSampleExamOpen(false);
            navigate("/trial/exam", { state: { autoStart: true } });
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default SampleExamDialog;
